// extracted by mini-css-extract-plugin
export default {"menu":"burger-ingredients_menu__VjMRY","tab":"burger-ingredients_tab__CP3Dm","block":"burger-ingredients_block__P4gFP"};